<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-66 md-xsmall-size-80 mx-auto">
      <simple-wizard>
        <template slot="header">
          <h3 class="title">Approval Wizard status </h3>
          <h5 class="category">
            Fill the information below and submit the guidance for the next step
          </h5>
          <div class="md-layout">
            <div class="md-layout-item md-size-20 md-xsmall-size-20 mx-auto">
          Guidance Name:<b>{{guidance.name}}
            </b>
            </div>
            <div class="md-layout-item md-size-20 md-xsmall-size-20 mx-auto">
          Guidance Number:<b>{{guidance.guidance_number}}</b>
            </div>
            <div class="md-layout-item md-size-20 md-xsmall-size-20 mx-auto">
          Department:<b>{{guidance.department.name}}</b>
            </div>
          </div>
        </template>

        <wizard-tab :before-change="() => validateStep('step1')">
          <template slot="label">
            Park
          </template>
          <first-step ref="step1" @on-validated="onStepValidated"></first-step>
        </wizard-tab>

        <wizard-tab :before-change="() => validateStep('step2')">
          <template slot="label">
            Review
          </template>
          <second-step
            ref="step2"
            @on-validated="onStepValidated"
          ></second-step>
        </wizard-tab>

        <wizard-tab :before-change="() => validateStep('step3')">
          <template slot="label">
            Certify
          </template>
          <third-step ref="step3" @on-validated="onStepValidated"></third-step>
        </wizard-tab>
        <wizard-tab :before-change="() => validateStep('step4')">
          <template slot="label">
            Approve
          </template>
          <fourth-step ref="step4" @on-validated="wizardComplete"></fourth-step>
        </wizard-tab>
      </simple-wizard>
    </div>
  </div>
</template>
<script>
import FirstStep from './approvalSteps/FirstStep';
import SecondStep from './approvalSteps/SecondStep';
import ThirdStep from './approvalSteps/ThirdStep';
import FourthStep from './approvalSteps/FourthStep';
import Swal from 'sweetalert2';
import { SimpleWizard, WizardTab } from '@/components';

export default {
    data () {
        return {
            wizardModel: {},
            guidance: {
                type: 'guidances',
                name: null,
                guidance_number: null,
                duration: null,
                start_date: null,
                end_date: null,
                department: {
                    id: null,
                    type: 'departments',
                },
                relationshipNames: ['department','works'],
            },
        };
    },
    components: {
        FirstStep,
        SecondStep,
        ThirdStep,
        FourthStep,
        SimpleWizard,
        WizardTab
    },
    methods: {
        async update () {
            if (
                this.$isDemo == 1 &&
              ['1', '2', '3'].includes(this.$route.params.id)
            ) {
                await this.$store.dispatch(
                    'alerts/error',
                    'You are not allowed to change data of default roles.'
                );
                return;
            }
            try {
                this.guidance.status = { reason:'Yahaya' };
                console.log(this.guidance);
                await this.$store.dispatch('guidances/update', this.guidance);
                await this.$store.dispatch(
                    'alerts/success',
                    'Guidance updated successfully.'
                );
                this.goBack();
            } catch (e) {
                if (e.response.data.errors[0]) {
                    await this.$store.dispatch(
                        'alerts/error',
                        e.response.data.errors[0].detail
                    );
                    this.setApiValidation(e.response.data.errors);
                } else {
                    await this.$store.dispatch(
                        'alerts/error',
                        'Oops, something went wrong!'
                    );
                }
            }
        },
        validateStep (ref) {
            console.log(this.guidance);
            this.update();
            return this.$refs[ref].validate();
        },
        onStepValidated (validated, model) {
            this.wizardModel = { ...this.wizardModel, ...model };
        },
        wizardComplete () {
            Swal.fire({
                title: 'Summary',
                text: 'You have Approved This Muongozo',
                type: 'success',
                confirmButtonClass: 'md-button md-success',
                buttonsStyling: false
            });

            this.goToView(this.$route.params.id);
        },

        async get () {
            try {
                const id = this.$route.params.id;
                await this.$store.dispatch('guidances/get', id);
                this.guidance = this.$store.getters['guidances/guidance'];
            } catch (e) {
                await this.$store.dispatch(
                    'alerts/error',
                    'Oops, something went wrong!'
                );
            }
        },
        goToView (id) {
            this.$router.push({ name: 'View Guidance', params: { id } });
        },

    },

    created () {
        this.get();
        console.log(2);
    },
};
</script>
